goog.provide("shadow.js.shim.module$$carbon$icons_react$es$ShoppingCart$default");
shadow.js.shim.module$$carbon$icons_react$es$ShoppingCart$default = shadow.js.require(373, {}).default;
